import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';
import MuiListItemIcon from '@material-ui/core/ListItemIcon';

import units from '../theme/units';

type ListItemIconProps =
  import('@material-ui/core/ListItemIcon').ListItemIconProps;

const useStyles = makeStyles(() => ({
  smallIcon: {
    minWidth: units.rem(2.5),
    fontSize: units.rem(1.25),
  },
}));

interface Props {
  iconSize?: 'small' | 'large';
}

const ListItemIcon: React.FC<Props & ListItemIconProps> = ({
  iconSize = 'large',
  className,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <MuiListItemIcon
      {...rest}
      className={cx(className, iconSize === 'small' && classes.smallIcon)}
    />
  );
};

export default ListItemIcon;
